import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Enums } from '../../../enums/enums';
import * as Models from '../../../models/models-index';
import { HelpTextService } from '../../../services/help/helpText.service';

type MetricOutput = { "value": string | number | Date, "trend": number, "subtitleOneValue": string | number | Date, "subtitleOneLabel" };

@Component({
  selector: 'kpi-dual-metric-detailed',
  templateUrl: './kpi-dual-metric-detailed.component.html',
  styleUrls: ['./kpi-dual-metric-detailed.component.scss']
})
export class KpiDualMetricDetailedComponent implements Models.ElementComponent, OnInit {

  @Input() dataSet: Models.DataSet;
  @Input() settings: Models.ElementSettings;
  @Input() locale: string;

  title;
  titleIconClasses;

  metrics: MetricOutput[] = [];

  constructor(private helpTextService: HelpTextService) {
  }

  ngOnInit() {

    const row = this.dataSet.rows[0];

    if (!this.settings.metrics || this.settings.metrics.length === 0) {
      throw new Error("No metrics defined");
    }

    this.settings.metrics.forEach(metric => {
      const metricIndex = this.dataSet.columns.findIndex(col => col.name === metric.name);
      const metricPreviousPeriodIndex = this.dataSet.columns.findIndex(col => col.name === metric.previousPeriod);
      const metricIndexPOP = this.dataSet.columns.findIndex(col => col.name === metric.pop);

      const subtitleOneValue = row[metricPreviousPeriodIndex]?.label ?? row[metricPreviousPeriodIndex]?.value;
      const subtitleOneLabel = "Prev. Period:";
      this.metrics.push({ "value": row[metricIndex].label ?? row[metricIndex].value, "trend": this.dataSet.rows[0][metricIndexPOP]?.value as number,"subtitleOneValue": subtitleOneValue, "subtitleOneLabel": subtitleOneLabel });
    });

    this.title = this.settings.title;
    this.titleIconClasses = this.settings.titleIconClasses;
  }

  getTrendArrowIconClass(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);

    if (isTrendUp === null || trend === 0) {
      return 'fa fa-horizontal-rule';
    } else if (trend > 0) {
      return 'fa fa-chevron-circle-up chevron-icon';
    } else if (trend < 0) {
      return 'fa fa-chevron-circle-down chevron-icon';
    }
  }

  getTrendIconColor(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);

    if (isTrendUp === null) {
      return 'bg-yellow';
    } else if (!isTrendUp) {
      return 'bg-red';
    } else if (!!isTrendUp) {
      return 'bg-green';
    }
  }

  getTrendColor(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);
    if (isTrendUp == null) {
      return 'text-yellow';
    } else if (!!isTrendUp) {
      return 'text-green';
    } else if (!isTrendUp) {
      return 'text-red';
    }
  }

  isTrendUp(value: number) {
    if (!value || value === 0)
      return null;

    return value > 0
      ? this.settings.metricInverted ? false : true
      : this.settings.metricInverted ? true : false;
  }

  openHelpTextClicked(): void {
    this.helpTextService.openHelp(this.settings.helpTextKey, this.settings.helpTextTitle);
  }

}